import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';

import DownloadIcon from '@mui/icons-material/VerticalAlignBottom';
import { useMassActionCsvExport } from 'src/components/massAction/state/massAction';

const CsvExportButton = () => {
  const { t } = useTranslation();
  const executeExport = useMassActionCsvExport();

  return (
    <Tooltip title={t('smartmessaging.massAction.navButton.csvExport')}>
      <IconButton
        aria-label="clear"
        onClick={e => {
          e.preventDefault();
          executeExport();
        }}
        color="secondary"
        size="large"
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  );
};

export default CsvExportButton;
